export default class PricingModel {
	spectatorJunior = 0.0
	spectatorSenior = 0.0
	flyerJunior = 0.0
	flyerSenior = 0.0

	memberJunior = 0.0
	memberSenior = 0.0
}
